import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter, map, first, tap } from 'rxjs/operators';
import { RoutingService } from 'src/app/core/services/routing.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-profil-or-org',
  templateUrl: './profile-or-org.component.html',
  styleUrls: []
})
export class ProfileOrOrgComponent {
  constructor(
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private routingService: RoutingService
  ) {
    this.activatedRoute.params
      .pipe(
        filter(
          (params) =>
            params.hasOwnProperty('id') && params.hasOwnProperty('name')
        ),
        map((params) => this.redirectTo(params.id))
      )
      .subscribe((_) => _);
  }

  private redirectTo(id: string) {
    this.userService
      .getUserTypeById(id)
      .pipe(
        filter((_) => !!_),
        first()
      )
      .subscribe((type) =>
        this.routingService.goToProfileOrOrg(type, {
          skipLocationChange: true,
          queryParams: this.activatedRoute.snapshot.queryParams
        })
      );
  }
}
